import { Stack } from '@chakra-ui/react'
import { FIRST_PAGE, PaginationGroupItems } from './PaginationGroupItems'
import { Button, IconArrow } from '@gazin/ecommerce-ui'
import { useRouter } from 'next/router'
import { makePageUrl } from 'src/util/url'
import { PageLink } from './navigation'

interface PaginationProps {
  pagination: {
    firstPage: number
    currentPage: number
    nextPage: number
    lastPage: number
    prevPage: number
  }
  // Opt-in (hotsite, TNDC-438): "Anterior"/"Próximo" desabilitados saem sem <a href>. Sem
  // a prop, o link continua, como na busca e nas avaliações (na página 1 o "Anterior"
  // aponta para a própria página). Critério 19: nenhum link inválido ou duplicado.
  omitDisabledLinks?: boolean
  // Opt-in: troca de página no cliente, preservando o estado da página (filtros do hotsite).
  onNavigate?: (page: number) => void
}

const buttonStyle = {
  size: 'sm',
  fontSize: 'sm',
  width: '28',
  bg: 'white',
  border: '1px solid',
  borderColor: '#DCDDE3',
  borderRadius: '.1875rem',
  color: '#646981',
} as const

export const PaginationComponent = ({
  pagination,
  omitDisabledLinks = false,
  onNavigate,
}: PaginationProps) => {
  const { currentPage, nextPage, lastPage } = pagination
  const route = useRouter()

  const paginationGroupItemsProps = {
    currentPage,
    lastPage,
    nextPage,
    onNavigate,
  }

  const isFirstPage = currentPage === FIRST_PAGE
  const isLastPage = currentPage === lastPage

  const previousButton = (
    <Button
      {...buttonStyle}
      isDisabled={isFirstPage}
      leftIcon={<IconArrow color="primary.500" transform="rotate(180deg)" />}
    >
      Anterior
    </Button>
  )

  const nextButton = (
    <Button
      {...buttonStyle}
      isDisabled={isLastPage}
      rightIcon={<IconArrow color="primary.500" />}
    >
      Próximo
    </Button>
  )

  return (
    <Stack
      direction={['column', 'row']}
      spacing="2"
      align="center"
      mt="8"
      justify="space-between"
    >
      {omitDisabledLinks && isFirstPage ? (
        previousButton
      ) : (
        <PageLink
          href={makePageUrl(pagination.prevPage, route)}
          page={pagination.prevPage}
          onNavigate={onNavigate}
        >
          {previousButton}
        </PageLink>
      )}

      <PaginationGroupItems {...paginationGroupItemsProps} />

      {omitDisabledLinks && isLastPage ? (
        nextButton
      ) : (
        <PageLink
          href={makePageUrl(pagination.nextPage, route)}
          page={pagination.nextPage}
          onNavigate={onNavigate}
        >
          {nextButton}
        </PageLink>
      )}
    </Stack>
  )
}
